import {Component, Input, OnInit} from '@angular/core';
import moment from "moment/moment";
import {numberWithCommas} from "../../BATCH_COLORS";

@Component({
    selector: 'app-val-premoney-for-day-batch-card',
    templateUrl: './val-premoney-for-day-batch-card.component.html',
    styleUrls: ['./val-premoney-for-day-batch-card.component.scss']
})
export class ValPremoneyForDayBatchCardComponent implements OnInit {

    @Input() batch: string;
    @Input() color: string;

    private _data: any;
    get data() {
        return this._data;
    }

    @Input() set data(val: any) {
        this._data = val;
        if (val) {
            this.chartWeeklyExpenses = {
                chart: {
                    animations: {
                        enabled: true
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'line',
                    sparkline: {
                        enabled: true
                    }
                },
                colors: [this.color],
                series: [
                    {
                        name: 'Val. Media Premoney/Giorno',
                        data: this._data.series
                    }
                ],
                stroke: {
                    curve: 'smooth'
                },
                tooltip: {
                    theme: 'dark',
                    x: {
                        format: 'dd MMM'
                    }
                },
                xaxis: {
                    type: 'category',
                    categories: this._data.labels,
                },
                yaxis: {
                    labels: {
                        formatter: (value) => {
                            return `${numberWithCommas(value)}`;
                        },
                    }
                },
            };

        }
    }

    chartWeeklyExpenses: any;

    constructor() {
    }

    ngOnInit(): void {

    }

}
